export default "__VITE_ASSET__D567zEOZ__"